import React, { useEffect, useState } from "react"
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TextField,
  IconButton,
  FormControl,
} from "@mui/material"
import Grid from "@mui/material/Grid2"
import ClearIcon from "@mui/icons-material/Clear"
import SecondaryButton from "@/components/Buttons/SecondaryButton"
import CustomAutoComplete from "@/components/Select/CustomAutoComplete"

const SalesReturnProductable = ({
  controller,
  control,
  setValue,
  errors,
  name,
  label = "Products",
  options = [],
  isSubmitting,
  defaultProducts = [],
}) => {
  const Controller = controller
  const [items, setItems] = useState(defaultProducts)

  const handleAddedItem = (item) => {
    if (!item) return
    setItems((prev) => [
      ...prev,
      {
        ...item, // full item: id, sku, code, etc.
        price: item.total || 0,
      },
    ])
  }

  const handleQuantityChange = (index, value) => {
    const updated = [...items]
    updated[index].quantity = Number(value)
    setItems(updated)
  }

  const handlePriceChange = (index, value) => {
    const updated = [...items]
    updated[index].price = Number(value)
    setItems(updated)
  }

  const handleRemoveItem = (item) => {
    setItems((prev) => prev.filter((i) => i.id !== item.id))
  }

  const handleReset = () => {
    setItems([])
  }

  useEffect(() => {
    if (control) {
      setValue(name, items)
    }
  }, [items, control, name])

  return (
    <div>
      <Typography variant="h6" sx={{ fontWeight: 500, marginBottom: 2 }}>
        {label}
      </Typography>

      <Grid container spacing={2} sx={{ marginBottom: 2 }}>
        <Grid size={12}>
          <TableContainer
            component={Paper}
            sx={{ boxShadow: "none", borderRadius: "7px" }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>S.N.</TableCell>
                  <TableCell>Item</TableCell>
                  <TableCell>Quantity</TableCell>
                  <TableCell>Price</TableCell>
                  <TableCell>Remove</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <Controller
                  name={name}
                  control={control}
                  defaultValue={defaultProducts}
                  render={() =>
                    items.map((item, index) => (
                      <TableRow key={item.id}>
                        {console.log("item", item)}
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>
                          <Typography>{item.sku}</Typography>
                          <Typography variant="caption">{item.code}</Typography>
                        </TableCell>
                        <TableCell>
                          <TextField
                            size="small"
                            type="number"
                            value={item.quantity}
                            onChange={(e) =>
                              handleQuantityChange(index, e.target.value)
                            }
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            size="small"
                            type="number"
                            value={item.price}
                            onChange={(e) =>
                              handlePriceChange(index, e.target.value)
                            }
                          />
                        </TableCell>
                        <TableCell>
                          <IconButton onClick={() => handleRemoveItem(item)}>
                            <ClearIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  }
                />
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

        <Grid size={6}>
          <FormControl fullWidth>
            <CustomAutoComplete
              label="Add Product"
              options={options}
              optionLabel="sku"
              optionValue="id"
              onChange={handleAddedItem}
              error={!!errors[name]}
              returnObject={true}
              helperText={errors[name]?.message}
            />
          </FormControl>
        </Grid>

        <Grid size={2}>
          <SecondaryButton fullWidth label="Reset" onClick={handleReset} />
        </Grid>
      </Grid>
    </div>
  )
}

export default SalesReturnProductable
